<template>
  <div>
      <!-- <router-view></router-view> -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
name:'app'
}
</script>

<style>
.upload-demo{
  display: inline-block;
  margin: 0px 10px;
}
.el-tooltip__popper{max-width:80%}
</style>
